// extracted by mini-css-extract-plugin
export default {"container":"BRn1N","content":"vZosj","title":"J8WSX","subtitle":"bzBF2"};